import {
  EXTERNAL_API_CLONE_EXTERNAL_API_BEGIN,
  EXTERNAL_API_CLONE_EXTERNAL_API_SUCCESS,
  EXTERNAL_API_CLONE_EXTERNAL_API_FAILURE,
  EXTERNAL_API_CLONE_EXTERNAL_API_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function cloneExternalApi(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EXTERNAL_API_CLONE_EXTERNAL_API_BEGIN,
    });
    const { projectId, version } = args;
    let header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/external-api/clone`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: EXTERNAL_API_CLONE_EXTERNAL_API_SUCCESS,
            data: res,
          });
          toast.success('Cloned Successfully !', {});
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: EXTERNAL_API_CLONE_EXTERNAL_API_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Clone Failed: ${errMsg}`);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCloneExternalApiError() {
  return {
    type: EXTERNAL_API_CLONE_EXTERNAL_API_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EXTERNAL_API_CLONE_EXTERNAL_API_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        cloneExternalApiPending: true,
        cloneExternalApiError: null,
      };

    case EXTERNAL_API_CLONE_EXTERNAL_API_SUCCESS:
      // The request is success
      return {
        ...state,
        cloneExternalApiPending: false,
        cloneExternalApiError: null,
      };

    case EXTERNAL_API_CLONE_EXTERNAL_API_FAILURE:
      // The request is failed
      return {
        ...state,
        cloneExternalApiPending: false,
        cloneExternalApiError: action.data.error,
      };

    case EXTERNAL_API_CLONE_EXTERNAL_API_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        cloneExternalApiError: null,
      };

    default:
      return state;
  }
}
